import { use, useEffect, useState } from "react";

export const useTabulationContainer = (
  initialTabulationValue = [],
  onRemoveTabulation = () => {},
) => {
  const [tabulations, setTabulations] = useState(initialTabulationValue);

  useEffect(() => {
    setTabulations(initialTabulationValue);
  }, [initialTabulationValue]);

  const handleRemoveItem = (id) => {
    setTabulations(tabulations.filter((item) => item.id !== id));
    onRemoveTabulation(id);
  };
  return { tabulations, handleRemoveItem };
};
